import * as React from 'react';

import type {CoreEntityType, FilterObject} from 'nutshell-core/types';

import type {Flow} from 'flow-to-typescript-codemod';

import {ActionsDefault} from './actions-default';
import type {Props as ActionsDefaultOwnProps} from './actions-default';
import {CreateLeadsButton} from './create-leads-button';

type ActionsDefaultProps = Flow.Diff<
    ActionsDefaultOwnProps,
    {
        entityType: CoreEntityType;
    }
>;

type Props = ActionsDefaultProps & {
    filters: FilterObject[];
    q: string;
    entityData: {
        string: {
            id: string;
            primaryName: string;
        };
    };
    massSelect: boolean;
    allItems: any[];
    selectedItems: string[];
    omittedItems: string[];
    canAccessCrm: boolean;
    selectedCount: number;
};

export function ActionsAccount(props: Props) {
    const {
        filters,
        q,
        allItems,
        entityData,
        massSelect,
        selectedCount,
        selectedItems,
        omittedItems,
        canAccessCrm,
        ...restProps
    } = props;

    return (
        <>
            {canAccessCrm && (
                <CreateLeadsButton
                    filters={filters}
                    q={q}
                    allItems={allItems}
                    isDisabled={selectedCount === 0}
                    entityData={entityData}
                    entityType={'accounts'}
                    massSelect={massSelect}
                    selectedCount={selectedCount}
                    selectedItems={selectedItems}
                    omittedItems={omittedItems}
                />
            )}
            <ActionsDefault
                {...restProps}
                entityType={'accounts'}
                filters={filters}
                massSelect={massSelect}
                selectedCount={selectedCount}
                selectedItems={selectedItems}
                allItems={allItems}
            />
        </>
    );
}
